import e from "react";
var n = function() {
  return /* @__PURE__ */ e.createElement("svg", {
    fill: "currentColor",
    width: "10",
    height: "5",
    viewBox: "0 0 10 5"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M0,5l5,-5l5,5Z"
  }));
}, c = function() {
  return /* @__PURE__ */ e.createElement("svg", {
    fill: "currentColor",
    width: "10",
    height: "5",
    viewBox: "0 0 10 5"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M0,0l10,0l-5,5Z"
  }));
};
export {
  c as DecrementIcon,
  n as IncrementIcon
};
